var _polygon, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 0,100 100,100",
    fill: "#a3ffa3",
    stroke: "#578d57",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 0,
    stroke: "#578d57",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 100,
    stroke: "#578d57",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfSquare);
export default __webpack_public_path__ + "static/media/half-square.e7c997f7c4e26bc1c1b5536e7403fbe6.svg";
export { ForwardRef as ReactComponent };